import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageModule } from './page/page.module';


const routes: Routes = [  
        {
          path:'accueil',loadChildren:() => import('./page/page.module')
          .then(m=> m.PageModule)
        }, 
        {
          path: 'authentification', loadChildren:() =>import('./auth/auth-routing.module')
          .then(m=>m.AuthRoutingModule)
        },
        {
          path:'', loadChildren:() => import('./page/page.module')
          .then(m=>m.PageModule)
        }     

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule,PageModule]
})
export class AppRoutingModule { }
